import React, { Fragment } from "react";
import { Radio } from "antd";

import "./styles.css";
import RadioListItem from "./RadioListItem";

const RadioListing = ({
  options,
  onChange,
  value,
  className,
  wrapperClass,
  labelClass,
}) => {
  const listing = options && (
    <Radio.Group onChange={onChange} value={value} className={className}>
      {options.map((option, index) => {
        return (
          <Fragment key={option.value ?? option.label ?? index}>
            <RadioListItem {...option} labelClass={labelClass} />
          </Fragment>
        );
      })}
    </Radio.Group>
  );

  return <div className={`radio-listing ${wrapperClass || ""}`}>{listing}</div>;
};

export default RadioListing;
